import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { unregisterCurrentPushSubscription } from "../utils/pushNotifications";

const LogoutButton = () => {
    const { logout } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleLogout = async () => {
        await unregisterCurrentPushSubscription();
        logout();
        navigate("/login");
    };

    return (
        <button
            type="button"
            className="btn btn-danger"
            data-bs-dismiss="modal"
            onClick={handleLogout}
        >
            Se déconnecter
        </button>
    );
};

export default LogoutButton;
